import React from 'react';

export interface TableColumn<T> {
  key: string;
  header: React.ReactNode;
  render?: (row: T) => React.ReactNode;
}

export interface TableProps<T> {
  columns: TableColumn<T>[];
  data: T[];
  groupHeaders?: React.ReactNode;
}

export function Table<T extends Record<string, unknown>>({ columns, data, groupHeaders }: TableProps<T>) {
  return (
    <div style={{ overflowX: 'auto' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          {groupHeaders !== undefined && (
            <tr>
              <th
                colSpan={columns.length}
                style={{ textAlign: 'left', padding: '8px 12px', background: 'var(--surface-muted, #F3F4F6)' }}
              >
                {groupHeaders}
              </th>
            </tr>
          )}
          <tr>
            {columns.map(({ key, header }) => (
              <th key={key} style={{ textAlign: 'left', padding: '8px 12px', fontWeight: 600 }}>
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {columns.map(({ key, render }) => (
                <td key={key} style={{ padding: '8px 12px' }}>
                  {render ? render(row) : (row[key] as React.ReactNode)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Table;
